// @ts-nocheck
import {
    filtersAccordionStyles,
    ProductListFiltersAccordionStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { filtersProps } from "@store/Themes/common/props/filters";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

Object.assign<ProductListFiltersAccordionStyles>(filtersAccordionStyles, {
    accordion: {
        css: spacingStyles(`calc(-${filtersProps.spacing} - ${filtersProps.borderWidth})`, filtersProps.spacing),
    },
});
